
export type SentinelEntry = {
	label: string
	facility: SentinelFacility
	doors: SentinelDoor[]
}

export type SentinelFacilityDataEntry = {
	firstName: "required" | "optional"
	lastName: "required" | "optional"
	company: "required" | 'optional'
	isCitizen: "required" | 'disabled'
	nda: "required" | "disabled"
	reason: "required" | "optional" | "disabled"
	visiting: "required" | "optional" | "disabled"
	telephone: "required" | "optional" | "disabled"
}

export type SentinelFacilityAccessCode = {
	label: string,
	code: string
}

export type SentinelFacility = Partial<{
	// LogConfig id number
	id?: number
	accessCodes: SentinelFacilityAccessCode[]
	permitSelfRegistration: boolean
	badgeCodes: "disabled"
	autoCheckout: 'timed' | 'fixed' | "disabled"
	dataEntry: Partial<SentinelFacilityDataEntry>,
	accessCodesEnabled: boolean
	checkoutHrs: number
	checkoutTime: string
	visitorPhotos: "required" | 'optional' | 'notallowed'
	facilityName: string
	log: string
	logoImage?: string | null
	permitSelfCheckin: boolean
	permitSelfCheckout: boolean,
	badgeLogoImage?: string | null
}>

export type RequiredSentinelFacility = Omit<Required<SentinelFacility>, 'id' | 'dataEntry'> & {
	id?: number;
	dataEntry: SentinelFacilityDataEntry
}

export const createSentinelFacility = (): RequiredSentinelFacility => {
	return {
		id: undefined,
		badgeLogoImage: null,
		permitSelfRegistration: true,
		permitSelfCheckin: false,
		permitSelfCheckout: false,
		badgeCodes: "disabled",
		autoCheckout: "disabled",
		accessCodes: [],
		dataEntry: {
			firstName: "required",
			lastName: "required",
			company: "required",
			visiting: "required",
			reason: "required",
			isCitizen: "disabled",
			nda: "disabled",
			telephone: "disabled"
		},
		accessCodesEnabled: false,
		checkoutHrs: 0,
		checkoutTime: "0000",
		visitorPhotos: "required",
		logoImage: null,
		facilityName: "",
		log: "",
	};
};

export type SentinelDoor = Partial<{
	// LogConfig id number
	id?: number
	badgePrinting: 'disabled'
	accessPointName: string
	facility: string
	log: string
}>

export const createSentinelDoor = (): Required<SentinelDoor> => {
	return {
		id: -1,
		badgePrinting: "disabled",
		accessPointName: "",
		facility: "",
		log: ""
	};
};